/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2023-10-23 09:04:37
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/common/filters.js
 */
/**
 * @Auther: Qsan
 * @Date：2018年12月12日 17:03
 * @Desc：全局过滤器集
 */
import { getParam } from './utils'

export function toParamText(value, code) {
    return getParam(code, value).text
}

/**
 * 转换单位
 * @param value
 * @param unit
 * @param defaultValue
 * @returns {string}
 */
export function toUnit(value, unit, defaultValue = 0) {
    return `${value || defaultValue}${unit}`
}

// 过滤器
export function toTypeName(value) {
    let toName = ''
    switch (value) {
        case 10:
            toName = '开卡'
            break
        case 20:
            toName = '充值'
            break
        case 30:
            toName = '品项'
            break
        case 40:
            toName = '散客'
            break
        case 100:
            toName = '待支付'
            break
        case 200:
            toName = '支付中'
            break
        case 300:
            toName = '支付完成'
            break
        case 400:
            toName = '取消'
            break
        case 500:
            toName = '异常订单'
            break
        case 600:
            toName = '撤销订单'
            break
    }
    return toName
}



// WEBPACK FOOTER //
// ./src/common/filters.js